var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("aside", { staticClass: "side-rail" }, [
    _c("section", { staticClass: "side-rail__card side-rail__card--list" }, [
      _c("div", { staticClass: "side-rail__tabs" }, [
        _c(
          "button",
          {
            staticClass: "side-rail__tab",
            class: { active: _vm.tab === "current" },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.tab = "current"
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("Current")) + " ")]
        ),
        _c(
          "button",
          {
            staticClass: "side-rail__tab",
            class: { active: _vm.tab === "today" },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.tab = "today"
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("History")) + " ")]
        ),
      ]),
      _vm.isDetailOpen
        ? _c(
            "div",
            { staticClass: "side-rail__body" },
            [
              _c(
                "button",
                {
                  staticClass: "side-rail__back",
                  attrs: { type: "button" },
                  on: { click: _vm.closeDetail },
                },
                [
                  _c("span", { staticClass: "side-rail__back-chevron" }, [
                    _vm._v("‹"),
                  ]),
                  _vm._v(" " + _vm._s(_vm.$t("Bet detail")) + " "),
                ]
              ),
              _c("BetHistoryDetail", { staticClass: "side-rail__detail" }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isDetailOpen,
              expression: "!isDetailOpen",
            },
          ],
          staticClass: "side-rail__body",
        },
        [
          _c(
            "transition-group",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tab === "current",
                  expression: "tab === 'current'",
                },
              ],
              staticClass: "side-rail__rows",
              attrs: { tag: "ul", name: "rail-row" },
            },
            _vm._l(_vm.currentRows, function (row) {
              return _c("RailBetRow", { key: row.id, attrs: { row: row } })
            }),
            1
          ),
          _vm.historyMounted
            ? _c("BetHistory", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tab === "today",
                    expression: "tab === 'today'",
                  },
                ],
                staticClass: "side-rail__history",
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.hasTaiXiuTables
        ? _c(
            "section",
            { staticClass: "side-rail__quickplay" },
            [_c("QuickPlayPanel")],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }